var map = {
	"./arrow.svg": "84eb",
	"./articles.svg": "b282",
	"./banner-image.svg": "e5eb",
	"./check.svg": "5670",
	"./document.svg": "352a",
	"./download.svg": "8234",
	"./phone.svg": "2c7a",
	"./plus.svg": "97f9",
	"./position-pointer.svg": "eb34",
	"./services.svg": "e6a6",
	"./status-arrived.svg": "3c2c",
	"./status-cancelled.svg": "416d",
	"./status-delivered.svg": "c216",
	"./status-delivery.svg": "e074",
	"./status-preparing.svg": "151e",
	"./status-success.svg": "a922",
	"./status-transit.svg": "a79f",
	"./wrong.svg": "51db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b478";